export default __webpack_public_path__ + "static/media/apitools.382eca68.svg";